import { jsx } from "react/jsx-runtime";
import React from "react";
const PriceAddons = ({
  prefix = "",
  children
}) => {
  if (!children) {
    return null;
  }
  const childrenArray = React.Children.toArray(children);
  if (childrenArray.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: `${prefix}price-module__addons`, children: childrenArray.map((child, i) => /* @__PURE__ */ jsx("div", { className: `${prefix}price-module__addon`, children: child }, i)) });
};
var PriceAddons_default = PriceAddons;
export {
  PriceAddons,
  PriceAddons_default as default
};
